import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useRFINotificationsContext } from '../../RFINotificationsContext'
import { HelpMessage } from 'utils/constants'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import NotConfigured from './components/NotConfigured'
import { alphabeticalSort } from '@cims-online/shared'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../GroupFallback'
import ResponderTags from '../ResponderTags'
import CIMSSection from 'components/CIMSSection'

const ViewRFINotifications: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  const { data, recipients, responderEvents } = useRFINotificationsContext()
  const { every, byResponseDiscipline } = recipients(event)
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Request For Information')}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="Every" />}
          recipients={every}
        />
      </CIMSSection>
      <CIMSSection
        help={HelpMessage.RequestsForInformation.Notifications.ByResponseDiscipline(
          event
        )}
        title="Response Disciplines"
      >
        <CIMSCollapse
          noPanelsContent={<GroupFallback />}
          panels={data.rfiResponseDisciplines
            .sort(alphabeticalSort('name'))
            .map((responseDiscipline) => {
              const { id: key, name, description } = responseDiscipline
              const recipients = byResponseDiscipline.find(
                ({ responseDiscipline }) => responseDiscipline.id === key
              )?.recipients
              return {
                key,
                header: {
                  type: 'described',
                  name,
                  description,
                },
                children: (
                  <Space size="large" direction="vertical">
                    {responderEvents.some(
                      (responderEvent) => responderEvent.id === event.id
                    ) && (
                      <ResponderTags responseDiscipline={responseDiscipline} />
                    )}
                    <RecipientsTags
                      noRecipientsContent={
                        <NotConfigured type="Response Discipline" name={name} />
                      }
                      recipients={recipients}
                    />
                  </Space>
                ),
              }
            })}
        />
      </CIMSSection>
    </Space>
  )
}

export default ViewRFINotifications
